import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ORDER_TYPES } from '@app/constants/commonConstants';
import { useSelector } from 'react-redux';

const ItemsInOrderTablePriceLabel = ({
  currencyNotation,
  includeGST,
  taxDisclaimerMessage,
  isCheckFreightSuccessful,
  isQuantityMergeEnabled,
  orderType,
  showGstDagger,
  showGST
}) => {
  const [t] = useTranslation();
  const taxDisclaimerFeatureFlag = useSelector(
    state => state.featureFlag?.PCC_TaxInformationMessagesFlag
  );
  const includesGST = includeGST && !isCheckFreightSuccessful;
  const GSTConditional = includesGST ? t('GST_INCLUDES') : t('GST_EXCLUDES');

  const dagger = !isQuantityMergeEnabled ? (
    <sup>&dagger;&dagger;</sup>
  ) : (
    <sup>&dagger;</sup>
  );

  return (
    <>
      {`${
        orderType === ORDER_TYPES.OFFLINE_ORDER
          ? t('UNIT_PRICE')
          : t('TOTAL_PRICE')
      } (${currencyNotation})`}
      {showGST && (
        <p className="exclude-global mb-0 text-sm text-univers u-color--DarkGray">
          {/* If includeGST comes as true, column header displays 'Includes GST' on page load until taxAndFreight call is successful.
          This behavior is applicable on Pick up and Delivery page  */}
          {taxDisclaimerFeatureFlag ? taxDisclaimerMessage : GSTConditional}
          {showGstDagger && dagger}
        </p>
      )}
    </>
  );
};

ItemsInOrderTablePriceLabel.propTypes = {
  currencyNotation: PropTypes.string.isRequired,
  includeGST: PropTypes.bool,
  taxDisclaimerMessage: PropTypes.string,
  isCheckFreightSuccessful: PropTypes.bool,
  isQuantityMergeEnabled: PropTypes.bool,
  orderType: PropTypes.string,
  showGstDagger: PropTypes.bool,
  showGST: PropTypes.bool
};

export default ItemsInOrderTablePriceLabel;
